import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { DashboardResponse } from '@/api/types'
import { queryKeys } from '@/lib/queryKeys'
import { REFRESH_INTERVALS } from '@/lib/constants'

export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard,
    queryFn: () => api.get<DashboardResponse>('/admin/dashboard'),
    refetchInterval: REFRESH_INTERVALS.DASHBOARD,
  })
}
